import { padTwoDigits } from './lodash';

/**
 * Converts a timestamp into a human-readable "time ago" format.
 * @param timestamp
 * @param now
 * @returns
 */
export function timeAgo(
  timestamp: number | Date | string,
  now: number | Date = Date.now(),
  languages: Record<string, string> = {}
): string {
  const nowTime = typeof now === 'number' ? now : new Date(now).getTime();
  const timestampTime = typeof timestamp === 'number' ? timestamp : new Date(timestamp).getTime();

  const seconds = Math.floor((nowTime - timestampTime) / 1000);

  const intervals: [string, number][] = [
    ['year', 31536000],
    ['month', 2592000],
    ['week', 604800],
    ['day', 86400],
    ['hour', 3600],
    ['min', 60],
    ['s', 1],
  ];

  for (const [unitName, interval] of intervals) {
    const count = Math.floor(seconds / interval);
    if (count >= 1) {
      const unit = languages[unitName] || unitName;
      return `${count} ${unit} ${languages['ago'] || 'ago'}`;
    }
  }

  return languages['justNow'] || 'just now';
}

/**
 * Formats a date object into "YYYY-MM-DD hh:mm:ss" format.
 * @example
 * 👇️ `2023-04-11 16:21:23 (yyyy-mm-dd hh:mm:ss)`
 * console.log(formatDate(new Date()));
 * 👇️️ `2025-05-04 05:24:07 (yyyy-mm-dd hh:mm:ss)`
 * console.log(formatDate(new Date('May 04, 2025 05:24:07')));
 *
 * Date divider
 * 👇️ `01/04/2023 10:20:07 (MM/DD/YYYY hh:mm:ss)`
 * console.log(formatDate(new Date(), "/"));
 * @returns
 */
export function formatDate(date: Date, dateDivider = '-') {
  date = new Date(date);
  return (
    [date.getFullYear(), padTwoDigits(date.getMonth() + 1), padTwoDigits(date.getDate())].join(
      dateDivider
    ) +
    ' ' +
    [
      padTwoDigits(date.getHours()),
      padTwoDigits(date.getMinutes()),
      padTwoDigits(date.getSeconds()),
    ].join(':')
  );
}
